import PropTypes from 'prop-types';
import React from 'react';
import './style.scss';

export default function ConnectorDetailCell({ label = '', value = '', valueClass = '' }) {
  return value ? (
    <div className='connector__data-cell'>
      <h3 className='data-cell__label'>{label || value}</h3>
      <p className={`data-cell__value ${valueClass}`}>{value || 'N/A'}</p>
    </div>
  ) : null;
}

ConnectorDetailCell.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
  valueClass: PropTypes.string
};
